export const PURCHASE_REGISTER_REPORT_REQUEST = 'PURCHASE_REGISTER_REPORT_REQUEST';
export const PURCHASE_REGISTER_REPORT_SUCCESS = 'PURCHASE_REGISTER_REPORT_SUCCESS';
export const PURCHASE_REGISTER_REPORT_FAILURE = 'PURCHASE_REGISTER_REPORT_FAILURE';

export const GET_ACCOUNTS_OF_PURCHASE_BILL_REQUEST = 'GET_ACCOUNTS_OF_PURCHASE_BILL_REQUEST';
export const GET_ACCOUNTS_OF_PURCHASE_BILL_SUCCESS = 'GET_ACCOUNTS_OF_PURCHASE_BILL_SUCCESS';
export const GET_ACCOUNTS_OF_PURCHASE_BILL_REQUEST_FAILURE = 'GET_ACCOUNTS_OF_PURCHASE_BILL_REQUEST_FAILURE';

export const GET_ITEMS_OF_PURCHASE_BILL_REQUEST = 'GET_ITEMS_OF_PURCHASE_BILL_REQUEST';
export const GET_ITEMS_OF_PURCHASE_BILL_SUCCESS = 'GET_ITEMS_OF_PURCHASE_BILL_SUCCESS';
export const GET_ITEMS_OF_PURCHASE_BILL_REQUEST_FAILURE = 'GET_ITEMS_OF_PURCHASE_BILL_REQUEST_FAILURE';

export const GET_BROKERS_OF_PURCHASE_BILL_REQUEST = 'GET_BROKERS_OF_PURCHASE_BILL_REQUEST';
export const GET_BROKERS_OF_PURCHASE_BILL_SUCCESS = 'GET_BROKERS_OF_PURCHASE_BILL_SUCCESS';
export const GET_BROKERS_OF_PURCHASE_BILL_REQUEST_FAILURE = 'GET_BROKERS_OF_PURCHASE_BILL_REQUEST_FAILURE';

export const GET_LOTS_OF_PURCHASE_BILL_REQUEST = 'GET_LOTS_OF_PURCHASE_BILL_REQUEST';
export const GET_LOTS_OF_PURCHASE_BILL_SUCCESS = 'GET_LOTS_OF_PURCHASE_BILL_SUCCESS';
export const GET_LOTS_OF_PURCHASE_BILL_REQUEST_FAILURE = 'GET_LOTS_OF_PURCHASE_BILL_REQUEST_FAILURE';

export const GET_PURCHASE_BILLS_INVOICE_NUMBER_OF_PURCHASES_BILL_REQUEST = 'GET_PURCHASE_BILLS_INVOICE_NUMBER_OF_PURCHASES_BILL_REQUEST';
export const GET_PURCHASE_BILLS_INVOICE_NUMBER_OF_PURCHASES_BILL_SUCCESS = 'GET_PURCHASE_BILLS_INVOICE_NUMBER_OF_PURCHASES_BILL_SUCCESS';
export const GET_PURCHASE_BILLS_INVOICE_NUMBER_OF_PURCHASES_BILL_REQUEST_FAILURE = 'GET_PURCHASE_BILLS_INVOICE_NUMBER_OF_PURCHASES_BILL_REQUEST_FAILURE';

export const GET_FILTERS_OF_PURCHASES_BILL_SUCCESS = 'GET_FILTERS_OF_PURCHASES_BILL_SUCCESS';